export class InfoCpj {
    constructor({ proyecto, tipoFrmEmpresa } = {}) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;

        this.model = {
            id: {
                value: null,
                header: 'Código',
            },
            fecha: {
                value: new Date(),
                header: 'Fecha (día/mes/año):',
                required: 'Fecha es requerido',
            },
            pais: {
                value: null,
                header: 'País:',
                required: 'País es requerido'
            },
            provincia: {
                value: null,
                header: 'Provincia:',
                required: 'Provincia es requerido'
            },
            ciudad: {
                value: null,
                header: 'Ciudad:',
                required: 'Ciudad es requerida'
            },
            canton: {
                value: '',
                header: 'Ciudad:',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Ciudad es requerida'
            },
            compania: {
                value: '',
                header: 'Nombre de la compañía donde adquirió el bien:',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Compañía es requerida'
            },
            proyecto: {
                value: '',
                header: proyecto || 'Proyecto:',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 100,
                min: 3,
                required: 'Proyecto es requerido'
            },
            tipo_formulario: {
                value: null,
                header: 'Tipo de formulario:',
                required: 'Tipo de formulario es requerido'
            },
            tipo_solicitante: {
                value: null,
                header: 'Tipo de Solicitante:',
                required: 'Tipo de solicitante es requerido'
            },
            razon_social: {
                value: '',
                header: 'Razón Social / Nombre:',
                required: 'Razón Social / Nombre: es requerido',
                maxLength: 'Máximo 500 caracteres',
                filter: false,
                sort: true
            },
            identificacion: {
                value: '',
                header: 'No. RUC / Identificación tributaria:',
                required: 'No. RUC / Identificación tributaria es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
            },
            nacionalidad: {
                value: null,
                header: 'Nacionalidad:',
                required: ' Nacionalidad es Requerida'
            },
            fecha_ini_actividad: {
                value: null,
                header: 'Fecha de inicio de actividades:',
                required: 'Fecha inicioes de actividad es Requerida'
            },
            actividad_economica: {
                value: null,
                header: 'Actividad económica de la entidad donde labora o negocio propio:',
                required: 'Actividad económica es Requerida'
            },
            dirreccion_oficina: {
                value: '',
                header: 'Dirección oficina:',
                required: 'Dirección oficina es requerido',
                maxLength: 'Máximo 1000 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 1000,
                min: 4
            },
            pais_dd: {
                value: null,
                header: 'País:',
                required: 'País es requerido'
            },
            provincia_dd: {
                value: null,
                header: 'Provincia:',
                required: 'Provincia es requerido'
            },
            ciudad_dd: {
                value: null,
                header: 'Ciudad:',
                required: 'Ciudad es requerida'
            },
            canton_dd: {
                value: '',
                header: 'Ciudad',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Ciudad es requerida'
            },
            codigo_postal: {
                value: '',
                header: 'Apartado postal: ( en caso de residir en el extranjero), caso contrario colocar NA.',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 2,
                required: 'Apartado postal es requerido',
            },
            telefono_empresa: {
                value: '',
                header: 'Teléfono empresa:',
                required: 'No. de teléfono empresa es requerido',
                maxLength: 'Máximo 30 caracteres',
                minLength: 'Mínimo 7 caracteres',
                max: 30,
                min: 7,
            },
            email_pga_web: {
                value: '',
                header: 'Página web o dirección electrónica de la empresa:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Página web:',
                },
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Página web o dirección electrónica es requerido',

            },
            grupo: {
                value: [],
                header: 'Empresas:',
                required: 'Seleccione por lo menos una'
            },
            empresa: { value: null, export: true, header: 'Empresa:', required: 'Empresa es requerido' },
        }
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
        });
    }
    optionLabel = 'nombre';
}
